<div class="section-container mt-4" id="historico">
  <div class="section-title">
    <mat-icon class="material-symbols-outlined">history</mat-icon>
    <span>Histórico</span>
  </div>

  @if (isLoading) {
    <app-loading-box height="56" width="100%" marginTop="0"></app-loading-box>
    <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
    <app-loading-box height="56" width="100%" marginTop="12"></app-loading-box>
  } @else {
    <app-timeline-historico
      [itens]="itens"
      [exibirFiltros]="true"
      [permiteAnotacao]="podeAlterar"
      [registrandoAnotacao]="isRegistrandoAnotacao"
      [permiteExcluir]="true"
      [itemExcluindo]="itemExcluindo"
      (registrarAnotacao)="registrarAnotacao($event)"
      (excluir)="excluirAnotacao($event)">
    </app-timeline-historico>
  }
</div>
